<template>
  <div>
    <el-dialog :close-on-click-modal="false"
      title="菜品授权"
      :visible.sync="foodAuthorVisible"
      :before-close="foodAuthorHandleClose"
      width="53.2%"
      center
    >
      <el-divider></el-divider>
      <div class="tranStfer">
        <!-- <div style="text-align: center">
          <el-transfer
            style="text-align: left; display: inline-block"
            v-model="value4"
            filterable
            :left-default-checked="[2, 3]"
            :right-default-checked="[1]"
            :titles="['选择', '选择']"
            :button-texts="['删除', '添加']"
            :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
            @change="handleChange"
            :data="data"
          >
            <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span>
          </el-transfer>
        </div>-->
        <div class="contentQp">
          <div class="qpLeft">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="qpCenter">
            <div class="qpCenterInpu">
              <div>日库存</div>
              <el-input placeholder="数量"></el-input>
            </div>
            <div class="qpCenterBtn">
              <div>
                <div>
                  <button>选择</button>
                  <div>
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      class="allCheck"
                    >全部选择</el-checkbox>
                  </div>
                </div>
                <div>
                  <button>取消</button>
                  <button>全部取消</button>
                </div>
              </div>
            </div>
          </div>
          <div class="qpRight">
            <div class="qpRightOne">
              <span>注:</span>
              <span>数量为0的话就是不限制销售库存</span>
            </div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="itemBtnS">
          <el-button>清空</el-button>
          <el-button class="btnL">确认授权</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 菜单授权结束 -->
    <!-- 添加档口开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="foodTitle"
      :visible.sync="foodAddVisible"
      :before-close="foodAddHandleClose"
      width="28.5%"
      center
    >
      <el-divider></el-divider>
      <div class="addForm">
        <el-form ref="form" :model="form" label-width="130px">
          <el-form-item label="名称:">
            <span class="xingA">*</span>
            <el-input v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="档口登录账号:">
            <span class="xingB">*</span>
            <el-input v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="密码:">
            <span class="xingA">*</span>
            <el-input v-model="form.name" placeholder="请输入" type="password"></el-input>
            <span class="zhu">
              <span>注:</span>
              <span>数组与字母组合不超过12位</span>
            </span>
          </el-form-item>
          <el-form-item label="确认密码:">
            <span class="xingC">*</span>
            <el-input v-model="form.name" placeholder="请输入" type="password"></el-input>
            <span class="zhu">
              <span>注:</span>
              <span>6位</span>
            </span>
          </el-form-item>
          <el-form-item class="itemBtn">
            <el-button>重置</el-button>
            <el-button class="btnL">确认保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 添加档口结束 -->
    <!-- 添加类别开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="calssTitle"
      :visible.sync="classAddVisible"
      :before-close="classAddHandleClose"
      width="25.6%"
      center
    >
      <el-divider></el-divider>
      <div class="calssForm">
        <el-form ref="form" :model="form" label-width="50px">
          <el-form-item label="名称:">
            <span class="xingA">*</span>
            <el-input v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <span class="xingA">*</span>
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="itemBtn">
            <el-button>重置</el-button>
            <el-button class="btnL">确认保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 添加类别结束 -->
  </div>
</template>

<script>
const cityOptions = ["爱上咖啡哈萨克好尬水开关", "北京", "广州", "深圳"];
export default {
  data() {
    return {
      foodAuthorVisible: false, // 档口管理菜品授权
      foodAddVisible: false, // 添加档口
      classAddVisible: false, // 添加类别
      checkAll: false,
      checkedCities: ["上海", "北京"],
      cities: cityOptions,
      isIndeterminate: true,
      foodTitle: "",
      calssTitle: "",
      form: {
        name: ""
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  methods: {
    // 添加类别
    classAdd(row) {
      this.classAddVisible = true;
      if (row) {
        this.calssTitle = "编辑档口";
      } else {
        this.calssTitle = "添加档口";
      }
    },
    // 添加类别X
    classAddHandleClose() {
      this.classAddVisible = false;
    },
    // 添加档口
    foodAdd(row) {
      this.foodAddVisible = true;
      if (row) {
        this.foodTitle = "编辑档口";
      } else {
        this.foodTitle = "添加档口";
      }
    },
    // 添加档口X
    foodAddHandleClose() {
      this.foodAddVisible = false;
    },
    // 档口管理菜品授权
    foodAuthor() {
      this.foodAuthorVisible = true;
    },
    // 档口管理菜品授权X
    foodAuthorHandleClose() {
      this.foodAuthorVisible = false;
    },
    // 全部选择
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    }
  }
};
</script>

<style lang='less' scoped>
.calssForm {
  .el-input,
  .el-select {
    width: 400px;
  }
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #e74c3c;
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 20px;
    margin-left: -50px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.addForm {
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 20px;
    margin-left: -130px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .zhu {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #e74c3c;
    > span:nth-child(1) {
      margin-right: 10px;
    }
  }
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -108px;
    color: #e74c3c;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -80px;
    color: #e74c3c;
  }
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
}
.itemBtnS {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.contentQp {
  width: 100%;
  height: 490px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .qpLeft {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    /deep/.el-checkbox {
      width: 100%;
      margin-bottom: 15px;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
  .qpCenter {
    width: 15%;
    height: 450px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .qpCenterInpu {
      > div {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 5px;
        margin-bottom: 4px;
      }
      .el-input {
        width: 140px;
        margin-left: 4px;
      }
    }

    .qpCenterBtn {
      > div {
        > div:nth-child(1) {
          width: 100%;
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          > div:nth-child(2) {
            background: #ffffff;
            width: 140px;
            height: 40px;
            border: 1px solid #246deb;
            border-radius: 4px;
            text-align: center;
            line-height: 40px;
            color: #409eff;
            margin: 20px 0;
            /deep/.el-checkbox__input .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              display: none;
              color: #409eff;
            }
            .allCheck {
              color: #246deb;
            }
          }
          button {
            width: 140px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #246deb;
            border-radius: 4px;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #246deb;
            cursor: pointer;
          }
        }
        > div:nth-child(2) {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          button {
            width: 140px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #e74c3c;
            border-radius: 4px;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #e74c3c;
            margin-bottom: 20px;
            cursor: pointer;
          }
        }
      }
    }
    /deep/.el-form-item {
      margin-bottom: 10px;
    }
    /deep/.el-form-item__label {
      text-align: right;
      vertical-align: middle;
      float: left;
      line-height: 30px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .qpRight {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    .qpRightOne {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      margin-bottom: 10px;
      > span:nth-child(1) {
        margin-right: 10px;
      }
    }
    /deep/.el-checkbox {
      width: 100%;
      margin-bottom: 15px;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
}
.tranStfer {
  /deep/.el-transfer-panel {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    display: inline-block;
    vertical-align: middle;
    width: 367px;
    max-height: 100%;
    box-sizing: border-box;
    position: relative;
    height: 490px;
  }
  /deep/.el-transfer-panel__list.is-filterable {
    height: 490px;
    padding-top: 0;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4ecb73;
    border-color: #4ecb73;
  }
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
}
/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
</style>